import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { ReactComponent as AppsIcon } from '../images/tablet-svgrepo-com (1).svg';
import { PiPlantFill } from "react-icons/pi";
import { useEffect, useRef } from "react";
import * as mapas from "../utils/mapas";
import * as L from 'leaflet'

type PropsAplicativos = {
    visible: boolean,
    setVisible: Function
}

export default function Aplicativos(props: PropsAplicativos) {
    const mapRef = useRef<any>(null);
    useEffect(() => {
        try {
            if (mapRef.current !== null) {
                console.log('global.uf', global.uf)
                const mapa: L.Map = mapas.createMap(mapRef, mapas.mapas.googleHybrid())
                // mapas.sideBySide(mapa, mapas.mapas.googleHybrid(), mapas.mapas.arcgis())
            }
        } catch (e: any) {
            // messages.message(toastBC.current, 'Erro no carregamento do mapa:' + e)
        }
    }, [])
    return (
        <Dialog header={<div style={{ display: 'flex', alignItems: 'center', height: 10 }}><AppsIcon style={{ marginRight: 5 }} width={32} />APLICATIVOS</div>}
            visible={props.visible}
            maximizable
            style={{ width: '80vw', height: '80vh' }}
            contentStyle={{ display: 'flex', flexDirection: 'column' }}
            onHide={() => props.setVisible(false)}>
            <TabView pt={{
                root: { style: { display: 'flex', flexDirection: 'column', flexGrow: 1 } },
                panelContainer: { style: { flexGrow: 1 } }
            }}>
                <TabPanel header="Linha do Tempo de Cobertura Vegetal" leftIcon="pi pi-flag-fill mr-2" pt={{ content: { style: { height: '100%' } } }}>
                    <iframe src={'https://ee-jean.projects.earthengine.app/view/aiba-embrapa-historio-vegetao-vazio'} width="100%" style={{ height: '100%' }} frameBorder="0" />
                </TabPanel>

                <TabPanel header="Análise NDVI & NDWI de Terras Agrícolas" leftIcon="pi pi-flag-fill mr-2" pt={{ content: { style: { height: '100%' } } }}>
                    <iframe src={'https://ee-pradoosco.projects.earthengine.app/view/bahiafandvi'} width="100%" style={{ height: '100%' }} frameBorder="0" />
                </TabPanel>

                <TabPanel header="Soja e Algodão" leftIcon="pi pi-flag-fill mr-2" pt={{ content: { style: { height: '100%' } } }}>
                    <iframe src={'https://ee-jean.projects.earthengine.app/view/sojaalgodao'} width="100%" style={{ height: '100%' }} frameBorder="0" />
                </TabPanel>

            </TabView>
        </Dialog>
    )
}